module.exports = __webpack_public_path__ + "img/coround.ea331fb.png";